































































import Vue from 'vue'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import {
  DxColumn,
  DxColumnChooser,
  DxDataGrid,
  DxFilterRow, DxGrouping, DxGroupPanel,
  DxScrolling,
  DxSelection,
  DxSorting, DxStateStoring
} from 'devextreme-vue/data-grid'
import deMessages from "devextreme/localization/messages/de.json"
import frMessages from "devextreme/localization/messages/fr.json"
import itMessages from "devextreme/localization/messages/it.json"
import { loadMessages, locale } from 'devextreme/localization'
import { hexToRgba } from '@/services/hex-to-rgba'
import { SnackbarStateEnum } from '@/types/enums'
import { TranslateResult } from 'vue-i18n'
import TicketingSearchDialog from '@/components/ticketing/TicketingSearchDialog.vue'

interface ComponentData {
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  loading: boolean
  tableHeight: string
  showTicketingSearchDialog: boolean

  number: any | null
  description: any | null

  linkedList: any[]
  selectedItem: any | null

}

export default Vue.extend({
  name: 'TicketingLinked',

  components: {
    TicketingSearchDialog,
    DxDataGrid,
    DxColumn,
    DxColumnChooser,
    DxSorting,
    DxFilterRow,
    DxGroupPanel,
    DxGrouping,
    DxScrolling,
    DxSelection,
    DxStateStoring
  },

  props: {
    ticketId: Number
  },

  data (): ComponentData {
    return {
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      loading: false,
      tableHeight: '',
      showTicketingSearchDialog: false,

      number: null,
      description:  null,

      linkedList: [],
      selectedItem: null

    }
  },

  watch: {
    ticketId (newVal: number): void {
      if(newVal) {

      }
    }
  },

  computed: {
    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    selectedLanguageCode (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    }
  },

  methods: {
    onOpenTicketClick (): void {
      this.$emit('updateRoute', this.selectedItem.id)
    },

    rowClick(event: any): void {
      this.selectedItem = event.data
      this.number = this.selectedItem.number
      this.description = this.selectedItem.description
    },

    rowDblClick(event: any): void {
      this.$emit('updateRoute', event.data.id)
    },

    onAddLinkClick (): void {
      this.showTicketingSearchDialog = true
    },

    onSelectedTicket (ticket: any): void {
      console.log(ticket)
      this.closeTicketingSearchDialog()
    },

    closeTicketingSearchDialog (): void {
      this.showTicketingSearchDialog = false
    },

    onDeleteLinkClick (): void {

    },

    onSaveButtonClick (): void {

    },

    onResize (): void {
      setTimeout(() => {
        if(this.$refs.form && this.$vuetify.breakpoint.mdAndUp) {
          const vh = window.innerHeight
          if(vh > 500) {
            const height = (this.$refs.form as HTMLElement).clientHeight
            this.tableHeight = `height: calc(${vh}px - 172px - 60px - ${height}px)`
          } else {
            this.tableHeight = '300px'
          }
        } else {
          this.tableHeight = '300px'
        }
      },0)
    }
  },

  created (): void {
    loadMessages(deMessages)
    loadMessages(frMessages)
    loadMessages(itMessages)
    locale(this.selectedLanguageCode)
  },

  mounted (): void {
    this.linkedList = [
      {id: 1, number: 'PP25687', sentOn: '29.01.2024 10:00', product: 548961, responsible: 1, status: 1, priority: 1, externalReference: '', description: 'Nachrichten auf Kalenderart' },
      {id: 2, number: 'PP25477', sentOn: '10.02.2024 10:00', product: 534967, responsible: 1, status: 2, priority: 2, externalReference: '', description: 'Nachrichten auf Kalenderart' },
      {id: 3, number: 'PP29787', sentOn: '18.02.2024 10:00', product: 958946, responsible: 2, status: 2, priority: 3, externalReference: '', description: 'Nachrichten auf Kalenderart' },
      {id: 4, number: 'PP39687', sentOn: '19.02.2024 10:00', product: 128964, responsible: 2, status: 3, priority: 3, externalReference: '', description: 'Nachrichten auf Kalenderart' },
      {id: 10, number: 'PP74187', sentOn: '20.02.2024 10:00', product: 638963, responsible: 2, status: 1, priority: 3, externalReference: '', description: 'Nachrichten auf Kalenderart' }
    ]
  }
})
